/* Add Aria-label to price slider */
  window.onload = function () {
    try {
      const priceSliders = document.querySelectorAll(
        ".price_slider_wrapper .price_slider"
      );
      if (priceSliders.length === 0) {
        return;
      }
      priceSliders.forEach((priceSlider, sliderIndex) => {
        const startingPriceHandles = priceSlider.querySelectorAll(
          ".noUi-handle.noUi-handle-lower"
        );
        const endingPriceHandles = priceSlider.querySelectorAll(
          ".noUi-handle.noUi-handle-upper"
        );
        startingPriceHandles.forEach((handle, index) => {
          handle.setAttribute("aria-label", `Starting price`);
        });
        endingPriceHandles.forEach((handle, index) => {
          handle.setAttribute("aria-label", `Ending price`);
        });
      });
    } catch (e) {}
  };

/* Product All Style Buttons ADA Fix (Dark, White colors, etc.) */
/* Ignacio - Made these buttons tabbable to ADA when they should be*/
  try {
    const enhanceButtons = () =>
    document.querySelectorAll('a.pro-size, a.pro-size-active').forEach(btn => {
      btn.tabIndex = 0;
      btn.role = 'button';
      const name = btn.textContent.trim();
      btn.ariaLabel = btn.classList.contains('pro-size-active')
        ? `Selected Style Product`
        : `Other Style Product Page`;
    });

    enhanceButtons();
    new MutationObserver(() => enhanceButtons()).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  } catch (e) {}

/* "Shop Pay" button for installments: Add Aria-label */
/* Ruyi */
  try {
    const observer = new MutationObserver(() => {
      const paymentTermsElement = document.querySelector("shopify-payment-terms");
      if (paymentTermsElement && paymentTermsElement.shadowRoot) {
        const shadowRoot = paymentTermsElement.shadowRoot;
        const svgElement = shadowRoot.querySelector("svg");
        if (svgElement) {
          svgElement.setAttribute("aria-label", "Shop Pay icon");
          observer.disconnect();
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

/* "style_container" buttons (duo, single, etc.): ADA Fix to make all tabbable */
/* Ignacio */
  try {
    const observer = new MutationObserver(() => {
      document.querySelectorAll("input[type='radio']:not([aria-label]):not([aria-labelledby])").forEach((radio, index) => {
        // Skip hidden radios
        if (radio.offsetParent === null) return;
  
        // Try to find an associated label
        let label = document.querySelector(`label[for='${radio.id}']`);
        if (label && label.textContent.trim()) {
          const labelId = label.id || `label-for-radio-${index}`;
          radio.setAttribute("aria-labelledby", labelId);
          if (!label.id) label.id = labelId;
        } else {
          // If no label found, assign a generic aria-label
          radio.setAttribute("aria-label", `Radio button ${index + 1}`);
        }
  
        // Assign role="radio" if missing
        if (!radio.hasAttribute("role")) {
          radio.setAttribute("role", "radio");
        }
      });
    });
  
    // Start observing the document
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  
    // Run once immediately
    setTimeout(() => observer.takeRecords(), 0);
  
    // Stop observing after 5 seconds
    setTimeout(() => observer.disconnect(), 5000);
  } catch (error) {}

/* video element: Add aria-label for and img inside the video element */
/* Ruyi */
  try {
    document.addEventListener("DOMContentLoaded", function () {
      var videoElements = document.querySelectorAll("video");
      videoElements.forEach(function (videoElement) {
        var videoAriaLabel = videoElement.getAttribute("aria-label") || "Video";
        if (!videoElement.hasAttribute("aria-label")) {
          videoElement.setAttribute("aria-label", "Video");
        }
        var targetElements = videoElement.querySelectorAll("img");
        targetElements.forEach(function (imgElement) {
          if (!imgElement.hasAttribute("aria-label")) {
            imgElement.setAttribute("aria-label", videoAriaLabel);
          }
        });
      });
    });
  } catch (e) {}

/* Hidden Analytics iFrame causing ADA problems: Now hidden */
/* Ignacio */
  document.addEventListener("DOMContentLoaded", () => {
    try {
      // Add title to Shopify Preview Bar iframe
      const previewIframe = document.getElementById("PBarNextFrame");
      if (previewIframe && !previewIframe.title) {
        previewIframe.title = "Shopify Preview Bar Frame";
      }
  
      // handle iframe accessibility
      const updateIframeAccessibility = (iframe) => {
        const isHidden =
          iframe.getAttribute('aria-hidden') === 'true' ||
          iframe.tabIndex < 0 ||
          iframe.style.display === 'none' ||
          iframe.style.visibility === 'hidden' ||
          iframe.width === "0" ||
          iframe.height === "0";
  
        if (isHidden) {
          iframe.setAttribute("aria-hidden", "true");
          iframe.setAttribute("tabindex", "-1");
        } else if (!iframe.title) {
          iframe.title = "Embedded Frame";
        }
      };
  
      // Update all existing iframes
      document.querySelectorAll('iframe').forEach(updateIframeAccessibility);
  
      // Handle dynamically added tracking iframes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(({ addedNodes }) => {
          addedNodes.forEach((node) => {
            if (node.tagName === "IFRAME") {
              if (node.src.includes("doubleclick.net")) {
                node.setAttribute("aria-hidden", "true");
              }
              updateIframeAccessibility(node);
            }
          });
        });
      });
  
      observer.observe(document.body, { childList: true, subtree: true });
  
      // Also update existing doubleclick iframes
      document.querySelectorAll('iframe[src*="doubleclick.net"]').forEach((iframe) => {
        iframe.setAttribute("aria-hidden", "true");
      });
    } catch (error) {}
  });